/**
 * index.js
 *
 * Description: The main index component.
 * Author: Parsa Badri
 * Date: 26/03/2024
 */

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("weddingly"));

// If the app successfully reaches this point, the chunks have loaded correctly.
// We can clear the reload flag so that future deployments can trigger a reload if needed.
sessionStorage.removeItem("app_reloaded");

root.render(<App />);
